import { DatePicker, DatePickerProps } from "@mui/x-date-pickers";
import { Dayjs } from "dayjs";

function AppDatePicker(props: DatePickerProps<Dayjs>) {
  const { sx, slotProps, ...rest } = props;
  const textFieldSlotProps =
    typeof slotProps?.textField === "object" ? slotProps.textField : {};

  return (
    <DatePicker<Dayjs>
      {...rest}
      slotProps={{
        ...slotProps,
        textField: {
          size: "small",
          fullWidth: true,
          ...textFieldSlotProps,
        },
      }}
      sx={{
        marginBottom: "5px",
        bgcolor: "white",
        borderRadius: "4px",
        "& .MuiInputBase-input": {
          padding: "8.5px 14px",
        },
        ...sx,
      }}
    />
  );
}

export default AppDatePicker;
